<template>

    <form autocomplete="off" v-on:submit.prevent="saveData" class="trax-form-with-icons">

        <trax-ui-input type="text" icon="person" :placeholder="lang.polaris.account.username"
            v-model="form.username" :error="errors.username" required="1" v-if="withUsername">
        </trax-ui-input>

        <trax-ui-input type="email" icon="email" :placeholder="lang.polaris.account.email"
            v-model="form.email" :error="errors.email" required="1" v-if="!withUsername">
        </trax-ui-input>

        <trax-ui-input type="password" icon="lock_outline" :placeholder="lang.polaris.account.password"
            v-model="form.password" :error="errors.password" required="1">
        </trax-ui-input>
        
        <trax-ui-checkbox v-if="can_remember" :text="lang.polaris.account.remember_me" v-model="form.remember">
        </trax-ui-checkbox>

        <p class="text-center mt-2">
            <strong class="text-danger" v-if="errorMessage">{{ errorMessage }}</strong>
        </p>

        <div class="trax-form-actions text-center">
            <button type="submit" :class="'btn btn-round btn-'+color"> {{ action.label }} </button>
        </div>

    </form>

</template>

<script>
    export default {
    
        props: ['email', 'withUsername', 'remember', 'canRemember', 'color'],
        
        data: function() {
            return {
                lang: lang,
                intended_url: data.intended,
                endpoint: app_url + "trax/api/auth/login",
                form: {
                    username: '',
                    email: this.email,
                    password: '',
                    remember: this.remember
                },
                errors: {},
                errorMessage: null,
                can_remember: this.canRemember,
                action: {
                    align: 'center',
                    label: lang.polaris.account.log_in
                }
            }
        },

        methods: {

            saveData() {
                this.errors = {};
                this.errorMessage = null;
                this.postData(this.form);
            },

            postData(data) {
                var that = this;
                axios.post(this.endpoint, data)
                    .then(function () {
                        window.location = that.intended_url;
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data && error.response.data.errors) {
                            that.processErrors(error.response.data.errors);
                            that.errorMessage = '';
                        } else if (error.response && error.response.data && error.response.data.message) {
                            that.errorMessage = 'There is no active account with these credentials.';
                        } else {
                            that.errorMessage = 'There is no active account with these credentials.';
                        }
                    });
            },

            processErrors(errors) {
                for (var name in errors) {
                    var error = errors[name];
                    if (error instanceof Array) errors[name] = error[0];
                }
                this.errors = errors;
            }
        }
    }
</script>
